import './index.scss';

import { Component, ReactNode } from 'react';

import t from 'utils/i18n';
import { BraxSize } from '../../types';
import { BraxModal } from '../BraxModal';
import { BraxIcon } from '../BraxIcon';
import { BraxButton } from 'components/BraxButton';

export type BraxCriticalErrorProps = {
    title: ReactNode,
    description: ReactNode,
    size?: BraxSize,
    open?: boolean,
    onClose?: () => void
};

export class BraxCriticalError extends Component<BraxCriticalErrorProps> {

    static defaultProps = {
        title: 'Erro Crítico'
    };

    render() {
        const { title, description, ...props } = this.props;

        return (
            <BraxModal {...props}>
                <div className="brax-critical-error">
                    <BraxIcon icon="exclamation-mark" />

                    <h2>{ title }</h2>

                    <p>{ description }</p>

                    <BraxButton variant="primary" onClick={props.onClose}>{ t('Entendido') }</BraxButton>
                </div>
            </BraxModal>
        );
    }

}
